export default __webpack_public_path__ + "static/media/Broa-De-Noz.31a3f4f2.jpg";